import _toConsumableArray from "/home/runner/work/aws-otel.github.io/aws-otel.github.io/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/runner/work/aws-otel.github.io/aws-otel.github.io/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/runner/work/aws-otel.github.io/aws-otel.github.io/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/aws-otel.github.io/aws-otel.github.io/node_modules/@babel/runtime/helpers/esm/createClass.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var HttpRequest = /*#__PURE__*/function () {
  function HttpRequest(options) {
    _classCallCheck(this, HttpRequest);
    this.method = options.method || "GET";
    this.hostname = options.hostname || "localhost";
    this.port = options.port;
    this.query = options.query || {};
    this.headers = options.headers || {};
    this.body = options.body;
    this.protocol = options.protocol ? options.protocol.slice(-1) !== ":" ? "".concat(options.protocol, ":") : options.protocol : "https:";
    this.path = options.path ? options.path.charAt(0) !== "/" ? "/".concat(options.path) : options.path : "/";
    this.username = options.username;
    this.password = options.password;
    this.fragment = options.fragment;
  }
  _createClass(HttpRequest, [{
    key: "clone",
    value: function clone() {
      var cloned = new HttpRequest(_objectSpread(_objectSpread({}, this), {}, {
        headers: _objectSpread({}, this.headers)
      }));
      if (cloned.query) cloned.query = cloneQuery(cloned.query);
      return cloned;
    }
  }], [{
    key: "isInstance",
    value: function isInstance(request) {
      if (!request) return false;
      var req = request;
      return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    }
  }]);
  return HttpRequest;
}();
function cloneQuery(query) {
  return Object.keys(query).reduce(function (carry, paramName) {
    var param = query[paramName];
    return _objectSpread(_objectSpread({}, carry), {}, _defineProperty({}, paramName, Array.isArray(param) ? _toConsumableArray(param) : param));
  }, {});
}